var render = function render(){var _vm=this,_c=_vm._self._c;return _c('esg-base-dashboard-card',{attrs:{"title":"핵심 협력사 기준"}},[_c('esg-base-chart',{attrs:{"height":"300px"}},[_c('apex-chart',{attrs:{"type":"heatmap","options":_vm.chartOptions,"width":this.width,"height":this.height,"series":_vm.series}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }